import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Rule } from '../../interfaces/Rule';

class IsTypeOfPayment implements Rule {
  private type: 'special' | 'milestone' | 'maturity';

  public setType(type: 'special' | 'milestone' | 'maturity') {
    this.type = type;
    return this;
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    switch (this.type) {
      case 'special':
        return (
          application['loan_version']?.special_payment_amount !== undefined &&
          application['loan_version']?.special_payment_amount !== null &&
          application['loan_version']?.special_payment_amount !== 0
        );
      case 'milestone':
        // Selected_Milestone_Advance_Program__c can have Yes or the name of the program, so we need to check for the negative cases
        return (
          application['borrower_advance'] !== 'No' &&
          application['borrower_advance'] !== null &&
          application['borrower_advance'] !== undefined
        );
      case 'maturity': {
        const maturityPayment =
          application['loan_version']?.maturity_payment_amount;

        return !!maturityPayment;
      }
      default:
        return false;
    }
  }
}

export default new IsTypeOfPayment();
